import MatrixContainer from './Matrix';

export default MatrixContainer;
